<template>
  <Modal
    title="Trash Person"
    ref="modal"
    size="xs"
  >
    <div v-if="person">
      <p>
        Move <strong>{{ person.label || 'this person' }}</strong> to trash?
      </p>
      <p class="text-caption text-grey-6">
        Trashed persons can be restored later.
      </p>
    </div>

    <template v-slot:actions>
      <q-btn
        label="Cancel"
        flat
        @click="hide()"
      />
      <async-btn
        label="Trash"
        color="negative"
        icon="fa fa-trash"
        :task="task"
        @click="trashPerson"
      />
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin, ModalMixin } from '@/mixins';
import { Person } from '@/analysis/types';
import { Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { trash } from './person';

interface Data {
  person: Person | null;
}

export default defineComponent({
  emits: ['trashed'],
  mixins: [HasTaskMixin, ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  data(): Data {
    return {
      person: null,
    };
  },
  methods: {
    open(person: Person) {
      this.person = person;
      (this.$refs.modal as ModalElement).show();
    },
    trashPerson() {
      if (!this.person) return;

      this.task = trash(this.person.id);
      this.task.then((person: Person) => {
        this.$emit('trashed', person);
        (this.$refs.modal as ModalElement).hide();
        notify('Person moved to trash.');
      });
    },
  },
});
</script>
